mutation Inertia_CancelOrder($orderId: ID!) {
  cancelOrder(input: { orderId: $orderId }) {
    order {
      id
      status
    }
    errors
  }
}